import { render, staticRenderFns } from "./EcTextEditor.vue?vue&type=template&id=ccaecb00&scoped=true&"
import script from "./EcTextEditor.vue?vue&type=script&lang=ts&"
export * from "./EcTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EcTextEditor.vue?vue&type=style&index=0&id=ccaecb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaecb00",
  null
  
)

export default component.exports